import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const virtualAgentSettingsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtual-agent-settings',
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings',
	exact: true,
};
